export default class FavouriteJourneyViewModel {
    public id: number;
    public deviceId: string;
    public favouriteDate: string;
    public nickname: string;
    public description: string;
    public modifiedDate: string;
    public insertedDate: string;
    public image1: string;
    public image2: string;
    public image3: string;
    public image4: string;
    public image5: string;
}
